module.exports = new __parcel__URL__("pvp_surrender_button_disabled.488130f1.png").toString();